export default function requestPageState(page) {
    const query       = m.parseQueryString(location.search);
    const queryString = m.buildQueryString(Object.assign({ _t : Date.now() }, query));

    return m.request({ url : `/${page}.json?${queryString}` });
}
